// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"789add9b","977":"9483610e"}[chunkId] + ".chunk.js";
};